import { css } from 'styled-components'

const anchorBase = css`
  @property --underline-offset {
    syntax: '<length>';
    inherits: false;
    initial-value: 0;
  }

  color: inherit;
  text-decoration: underline;
  transition: text-decoration-color 0.2s, --underline-offset 0.2s;
  --underline-offset: 0.075em;
  text-underline-offset: var(--underline-offset);
  text-decoration-thickness: 1px;
`

const anchorBaseHover = css`
  --underline-offset: 0.15em;
  text-decoration-thickness: 2px;
`

export const styleAnchor = css`
  ${anchorBase}
  &:hover {
    ${anchorBaseHover}
  }

  @supports not (background: paint(something)) {
    &:hover {
      ${anchorBaseHover}
    }
  }
`
export const baseTransition = css`
  transition-duration: 0.4s;
  transition-timing-function: cubic-bezier(0.65, 0.05, 0.36, 1);
`

export const styleAnchorBlock = css`
  text-decoration: none;

  .anchor-block-child {
    ${anchorBase};
    text-decoration-color: transparent;
  }

  &:hover {
    .anchor-block-child {
      ${anchorBaseHover};
      text-decoration-color: inherit;
    }
  }

  @supports not (background: paint(something)) {
    &:hover {
      ${anchorBaseHover};
      text-decoration-color: inherit;
    }
  }
`

export const styleList = css`
  padding-left: 1rem;

  li:not(:last-child) {
    margin-bottom: 0.3rem;
  }

  p {
    margin: 0 0 0 0.5rem;
  }
`

export const styleCheckList = css`
  text-align: left;
  padding-left: 1.5rem;

  li {
    list-style: none;
    position: relative;

    span {
      position: absolute;
      left: -1.4rem;
      top: 0.1rem;
      width: 1rem;
      height: 1.2rem;
    }
  }
`

export const styleCheckListBlack = css`
  text-align: left;
  
  li {
    list-style: none;
    position: relative;
    
    span {
      background-color: black;
      border-radius: 50%;
      color: white;
      position: absolute;
      height: 0.9rem;
      width: 0.9rem;
      top: 0.2rem;
    }
  }
`

export const styleCheckListWhite = css`
  text-align: left;
  
  li {
    list-style: none;
    position: relative;
   
    span {
      background-color: white;
      border-radius: 50%;
      color: black;
      position: absolute;
      height: 0.9rem;
      width: 0.9rem;
      top: 0.2rem;
    }
  }
`


export const styleHelpList = css`
  text-align: left;

  li {
    list-style: none;
    position: relative;

    span {
      height: 1.2rem;
      left: -1.4rem;
      position: absolute;
      top: 0.35rem;
      width: 1.2rem;
    }
  }
`

export const stylePre = css`
  overflow-y: auto;
  overflow-x: hidden;
  background-color: ${({ theme }) => theme.colors.black[7]};
  border: solid 1px ${({ theme }) => theme.colors.black[6]};
  padding: 1rem;
  border-radius: 0.5rem;
`

export const styleBlockquote = css`
  border-left: solid 0.15rem ${({ theme }) => theme.colors.black[1]};
  padding-left: 1.5rem;
`
